import React, { useState, useEffect } from 'react'
import PieCard from '../../../../../charts/card/PieCard/PieCard'
import './style.scss';
import TrendChart from '../../../../../charts/barchart/TrendChart/TrendChart';
import DPDChart from '../../../../../charts/barchart/DpdChart/DPDChart';
import Agent from '../../../../../generic/agent/Agent';
// import Filter from '../../generic/filter/Filter';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterValues } from '../../../../../../redux/reducers';

const Collect = () => {

  const res = useSelector(state => state?.actions);
  const ptpRes = useSelector(state => state.ptp);
  const amount = useSelector(state => state.amount);
  const agentRes = useSelector(state => state.agent);
  const trend = useSelector(state => state.trend);

  const dispatch = useDispatch();

  //this needs dynamic default values, map from backend data and given value as ""
  const defaultFilterValues = {
    from: "",
    to: "",
    AGENT: "",
    AREA: "",
    BRANCH: "",
    PRODUCT: "",
    REGION: "",
    HUB: ""
  };

  useEffect(() => {
    dispatch(setFilterValues(defaultFilterValues));
  }, []);

  // console.log("============> trend", trend);

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const dpdData = useSelector(state => state?.dpdData?.data);

  const [data, setData] = useState(null);

  useEffect(() => {
    if (dpdData?.length > 0) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const dynamicData = months.map((month, index) => {
        const monthData = dpdData.filter(item => item.month === index + 1);

        if (monthData.length > 0) {
          const monthValues = { name: month };

          monthData.forEach((item) => {
            const valueKey = `${item.dpd}dpd`;
            monthValues[valueKey] = item.accounts;
          });

          return monthValues;
        } else {
          return null;
        }
      });

      setData(dynamicData.filter(monthData => monthData !== null));
    }
  }, [dpdData]);

  const trendData = {
    labels: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Charges',
        data: new Array(12).fill(0),
        backgroundColor: 'rgba(85, 21, 135, 1)',
        borderColor: 'rgba(85, 21, 135, 1)'
      },
      {
        label: 'Fees',
        data: new Array(12).fill(0),
        backgroundColor: 'rgba(142, 67, 201, 1)',
        borderColor: 'rgba(142, 67, 201, 1)'
      },
      {
        label: 'Interest',
        data: new Array(12).fill(0),
        backgroundColor: 'rgba(198, 134, 248, 1)',
        borderColor: 'rgba(198, 134, 248, 1)'
      },
      {
        label: 'Principal',
        data: new Array(12).fill(0),
        backgroundColor: 'rgba(178, 124, 240, 1)',
        borderColor: 'rgba(178, 124, 240, 1)'
      },
    ]
  };

  if (Array.isArray(trend?.data)) {
    trend?.data?.forEach(item => {
      const { month, debtType, payment, debtAmount } = item;
      const index = month - 1; // adjust index since monhts are 1-based

      switch (debtType) {
        case 'charges':
          if (month <= currentMonth) {
            trendData.datasets[0].data[index] += payment;
          } else {
            trendData.datasets[0].data[index] += debtAmount;
          }
          break;
        case 'fees':
          if (month <= currentMonth) {
            trendData.datasets[1].data[index] += payment;
          } else {
            trendData.datasets[1].data[index] += debtAmount;
          }
          break;
        case 'interest':
          if (month <= currentMonth) {
            trendData.datasets[2].data[index] += payment;
          } else {
            trendData.datasets[2].data[index] += debtAmount;
          }
          break;
        case 'principal':
          if (month <= currentMonth) {
            trendData.datasets[3].data[index] += payment;
          } else {
            trendData.datasets[3].data[index] += debtAmount;
          }
          break;
        default:
          break;
      }
    });
  }

  const paymentData = Array.isArray(trend?.data) ? trend?.data?.filter(item => item.month <= currentMonth)
    .reduce((acc, item) => {
      const existingItem = acc.find(i => i.name === item.debtType);
      if (existingItem) {
        existingItem.value += item.payment;
      } else {
        acc.push({ id: acc.length + 1, name: item.debtType, value: item.payment });
      }
      return acc;
    }, []) : []
  // console.log(paymentData);

  // Filter data based on the condition (current month > month)
  const debtAmountData = Array.isArray(trend?.data) ? trend?.data.filter(item => item.month > currentMonth)
    .reduce((acc, item) => {
      const existingItem = acc.find(i => i.name === item.debtType);
      if (existingItem) {
        existingItem.value += item.debtAmount;
      } else {
        acc.push({ id: acc.length + 1, name: item.debtType, value: item.debtAmount });
      }
      return acc;
    }, []) : []
  // console.log(debtAmountData);
  const agents = Array.isArray(agentRes.data) ? agentRes?.data?.map((item) => ({
    name: item.name,
    collectedAmount: item.collectedAmount?.toString(),
    workedAccounts: item.workedAccounts,
    actionsTaken: item.actionsTaken
  })) : [];

  const transformedPtpData = ptpRes?.data?.actionDetails?.map((item, index) => ({
    id: index + 1,
    name: item.actionType,
    value: item.totalActions
  }));
  const ptpLength = ptpRes.data.totalAction;
  const formattedPtpLength = formatAmount(ptpLength);

  const actionDetailsLength = res?.data?.totalAction;
  const formattedActionLength = formatAmount(actionDetailsLength);
  const transformedData = res?.data?.actionDetails?.map((item, index) => {
    return {
      id: index + 1,
      name: item.actionCode,
      value: item.totalActions
    };
  });
  // console.log(transformedData);
  const percentageChange = res?.data?.percentageChange;
  const ptpPercentageChange = ptpRes?.data?.percentageChange;

  const isPositive = percentageChange >= 0;
  const description = isPositive ? `${percentageChange}% up since yesterday`
    : `${percentageChange}% down since yesterday`;
  // console.log(description);

  const ptpIsPositive = ptpPercentageChange >= 0;
  const ptpDescription = ptpIsPositive ? `${ptpPercentageChange}% up since yesterday`
    : `${ptpPercentageChange}% down since yesterday`;

  const paymentTotals = {};

  function formatAmount(amount) {
    const numericAmount = parseFloat(amount);

    if (numericAmount >= 1000000) {
      return (numericAmount / 1000000).toFixed(2) + 'M';
    } else if (numericAmount >= 1000) {
      return (numericAmount / 1000).toFixed(2) + 'K';
    } else {
      return numericAmount.toFixed(2);
    }
  }

  const totalAmount = amount.data.totalAmount;
  const formattedAmount = formatAmount(totalAmount);

  amount?.data?.paymentResults?.forEach((result) => {
    if (!paymentTotals[result.paymentMethod]) {
      paymentTotals[result.paymentMethod] = 0;
    }
    paymentTotals[result.paymentMethod] += result.payment;
  });

  const transformedAmountData = Object.entries(paymentTotals).map(([name, value], index) => {
    return {
      id: index + 1,
      name: name,
      value: value
    };
  });

  return (
    <>
      <div className="collect-container">
        <div className='collect-container__piecards'>
          <PieCard
            data={transformedData}
            title="Actions"
            number={formattedActionLength}
            description={description}
          />
          <PieCard
            data={transformedPtpData}
            title="Arrangements/PTP"
            number={formattedPtpLength}
            description={ptpDescription}
          />
          <PieCard
            data={transformedAmountData}
            title="Collected Amount"
            number={formattedAmount}
            description="This reflects payments updated in system"
          />
        </div>
        <div className='collect-container__middle-component'>
          <div className='collect-container__middle-component__dpd'>
            <DPDChart data={data} />
          </div>
          <div className='collect-container__middle-component__table'>
            <Agent data={agents} />
          </div>
        </div>
        <div className='collect-container__trend-chart'>
          <TrendChart
            paymentData={paymentData}
            debtAmountData={debtAmountData}
            data={trendData} />
        </div>
      </div>
    </>
  )
}

export default Collect;